export default "__VITE_ASSET__cgpR8lCx__"